import Modal from "./Modal";
import Button from "./Button";

const ConfirmDialog = ({
  open,
  title =
    "Confirm action",
  message,
  confirmLabel =
    "Confirm",
  cancelLabel =
    "Cancel",
  variant =
    "danger",
  loading =
    false,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal
      open={open}
      title={title}
      eyebrow="Confirmation"
      onClose={
        loading
          ? undefined
          : onCancel
      }
      size="small"
      footer={
        <>
          <Button
            variant="secondary"
            onClick={
              onCancel
            }
            disabled={
              loading
            }
          >
            {cancelLabel}
          </Button>

          <Button
            variant={
              variant
            }
            onClick={
              onConfirm
            }
            loading={
              loading
            }
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      <p className="app-confirm-message">
        {message}
      </p>
    </Modal>
  );
};

export default ConfirmDialog;